import { THROW_IAE23kobfj9wdoxr as THROW_IAE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { enumEntries20mr21zbe3az4 as enumEntries } from '../../../../../../kotlin-kotlin-stdlib/kotlin/enums/EnumEntries.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var AvatarType_Retro_instance;
var AvatarType_RobohashSet1_instance;
var AvatarType_RobohashSet2_instance;
var AvatarType_RobohashSet3_instance;
var AvatarType_RobohashSet4_instance;
var AvatarType_RobohashSet5_instance;
var AvatarType_Multiavatar_instance;
var AvatarType_DicebearPixelArt_instance;
var AvatarType_DicebearAdventurer_instance;
var AvatarType_DicebearCroodles_instance;
var AvatarType_DicebearThumbs_instance;
var AvatarType_DicebearLorelei_instance;
function values() {
  return [AvatarType_Retro_getInstance(), AvatarType_RobohashSet1_getInstance(), AvatarType_RobohashSet2_getInstance(), AvatarType_RobohashSet3_getInstance(), AvatarType_RobohashSet4_getInstance(), AvatarType_RobohashSet5_getInstance(), AvatarType_Multiavatar_getInstance(), AvatarType_DicebearPixelArt_getInstance(), AvatarType_DicebearAdventurer_getInstance(), AvatarType_DicebearCroodles_getInstance(), AvatarType_DicebearThumbs_getInstance(), AvatarType_DicebearLorelei_getInstance()];
}
function valueOf(value) {
  switch (value) {
    case 'Retro':
      return AvatarType_Retro_getInstance();
    case 'RobohashSet1':
      return AvatarType_RobohashSet1_getInstance();
    case 'RobohashSet2':
      return AvatarType_RobohashSet2_getInstance();
    case 'RobohashSet3':
      return AvatarType_RobohashSet3_getInstance();
    case 'RobohashSet4':
      return AvatarType_RobohashSet4_getInstance();
    case 'RobohashSet5':
      return AvatarType_RobohashSet5_getInstance();
    case 'Multiavatar':
      return AvatarType_Multiavatar_getInstance();
    case 'DicebearPixelArt':
      return AvatarType_DicebearPixelArt_getInstance();
    case 'DicebearAdventurer':
      return AvatarType_DicebearAdventurer_getInstance();
    case 'DicebearCroodles':
      return AvatarType_DicebearCroodles_getInstance();
    case 'DicebearThumbs':
      return AvatarType_DicebearThumbs_getInstance();
    case 'DicebearLorelei':
      return AvatarType_DicebearLorelei_getInstance();
    default:
      AvatarType_initEntries();
      THROW_IAE('No enum constant com.zegreatrob.coupling.model.player.AvatarType.' + value);
      break;
  }
}
function get_entries() {
  if ($ENTRIES == null)
    $ENTRIES = enumEntries(values());
  return $ENTRIES;
}
var AvatarType_entriesInitialized;
function AvatarType_initEntries() {
  if (AvatarType_entriesInitialized)
    return Unit_instance;
  AvatarType_entriesInitialized = true;
  AvatarType_Retro_instance = new (AvatarType())('Retro', 0, null);
  AvatarType_RobohashSet1_instance = new (AvatarType())('RobohashSet1', 1, 'https://robohash.org/');
  AvatarType_RobohashSet2_instance = new (AvatarType())('RobohashSet2', 2, 'https://robohash.org/');
  AvatarType_RobohashSet3_instance = new (AvatarType())('RobohashSet3', 3, 'https://robohash.org/');
  AvatarType_RobohashSet4_instance = new (AvatarType())('RobohashSet4', 4, 'https://robohash.org/');
  AvatarType_RobohashSet5_instance = new (AvatarType())('RobohashSet5', 5, 'https://robohash.org/');
  AvatarType_Multiavatar_instance = new (AvatarType())('Multiavatar', 6, 'https://multiavatar.com/');
  AvatarType_DicebearPixelArt_instance = new (AvatarType())('DicebearPixelArt', 7, 'https://www.dicebear.com/styles/pixel-art');
  AvatarType_DicebearAdventurer_instance = new (AvatarType())('DicebearAdventurer', 8, 'https://www.dicebear.com/styles/adventurer');
  AvatarType_DicebearCroodles_instance = new (AvatarType())('DicebearCroodles', 9, 'https://www.dicebear.com/styles/croodles');
  AvatarType_DicebearThumbs_instance = new (AvatarType())('DicebearThumbs', 10, 'https://www.dicebear.com/styles/thumbs');
  AvatarType_DicebearLorelei_instance = new (AvatarType())('DicebearLorelei', 11, 'https://www.dicebear.com/styles/lorelei');
}
var $ENTRIES;
var AvatarTypeClass;
function AvatarType() {
  if (AvatarTypeClass === VOID) {
    class $ extends Enum() {
      constructor(name, ordinal, attribution) {
        super(name, ordinal);
        this.s2d_1 = attribution;
      }
    }
    initMetadataForClass($, 'AvatarType');
    AvatarTypeClass = $;
  }
  return AvatarTypeClass;
}
function AvatarType_Retro_getInstance() {
  AvatarType_initEntries();
  return AvatarType_Retro_instance;
}
function AvatarType_RobohashSet1_getInstance() {
  AvatarType_initEntries();
  return AvatarType_RobohashSet1_instance;
}
function AvatarType_RobohashSet2_getInstance() {
  AvatarType_initEntries();
  return AvatarType_RobohashSet2_instance;
}
function AvatarType_RobohashSet3_getInstance() {
  AvatarType_initEntries();
  return AvatarType_RobohashSet3_instance;
}
function AvatarType_RobohashSet4_getInstance() {
  AvatarType_initEntries();
  return AvatarType_RobohashSet4_instance;
}
function AvatarType_RobohashSet5_getInstance() {
  AvatarType_initEntries();
  return AvatarType_RobohashSet5_instance;
}
function AvatarType_Multiavatar_getInstance() {
  AvatarType_initEntries();
  return AvatarType_Multiavatar_instance;
}
function AvatarType_DicebearPixelArt_getInstance() {
  AvatarType_initEntries();
  return AvatarType_DicebearPixelArt_instance;
}
function AvatarType_DicebearAdventurer_getInstance() {
  AvatarType_initEntries();
  return AvatarType_DicebearAdventurer_instance;
}
function AvatarType_DicebearCroodles_getInstance() {
  AvatarType_initEntries();
  return AvatarType_DicebearCroodles_instance;
}
function AvatarType_DicebearThumbs_getInstance() {
  AvatarType_initEntries();
  return AvatarType_DicebearThumbs_instance;
}
function AvatarType_DicebearLorelei_getInstance() {
  AvatarType_initEntries();
  return AvatarType_DicebearLorelei_instance;
}
//region block: exports
export {
  get_entries as get_entries1xwhtxnyr68s0,
  valueOf as valueOffu817ds6o68l,
  AvatarType_DicebearAdventurer_getInstance as AvatarType_DicebearAdventurer_getInstance2vst99hnqwv7q,
  AvatarType_DicebearCroodles_getInstance as AvatarType_DicebearCroodles_getInstance2k24gdfv5cjs1,
  AvatarType_DicebearLorelei_getInstance as AvatarType_DicebearLorelei_getInstance35u8n1tl12ttx,
  AvatarType_DicebearPixelArt_getInstance as AvatarType_DicebearPixelArt_getInstance2r6glvnkh5gj6,
  AvatarType_DicebearThumbs_getInstance as AvatarType_DicebearThumbs_getInstancez484ldz81itk,
  AvatarType_Multiavatar_getInstance as AvatarType_Multiavatar_getInstancehq7kncjen0k2,
  AvatarType_Retro_getInstance as AvatarType_Retro_getInstance7yxtyc3hn0kf,
  AvatarType_RobohashSet1_getInstance as AvatarType_RobohashSet1_getInstance275qhk80f1fwu,
  AvatarType_RobohashSet2_getInstance as AvatarType_RobohashSet2_getInstance14sqxaomx686u,
  AvatarType_RobohashSet3_getInstance as AvatarType_RobohashSet3_getInstanceym076gs8lkdq,
  AvatarType_RobohashSet4_getInstance as AvatarType_RobohashSet4_getInstance14qfqvdy825gw,
  AvatarType_RobohashSet5_getInstance as AvatarType_RobohashSet5_getInstance2wzaog080hvrs,
};
//endregion

//# sourceMappingURL=AvatarType.mjs.map
